export default __webpack_public_path__ + "static/media/88_photo.1cda06a7.jpg";